import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const Section = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #1a1a1a;
  min-height: calc(100vh - 25px); /* Adjust height for Navbar and Footer */
  gap: 20px;
  margin-top: -165px;
`;

const SupportContent = styled.div`
  max-width: 800px;
  color: #f0f0f0;
  text-align: center;
  margin-bottom: 20px;

  h1 {
    font-size: 2.5rem;
    margin-bottom: 20px;
  }

  p {
    font-size: 1.2rem;
    margin-bottom: 15px;
  }

  a {
    color: #1e90ff;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const SearchBox = styled.input`
  width: 100%;
  max-width: 600px;
  padding: 10px 15px;
  font-size: 1rem;
  border: 1px solid #333;
  border-radius: 5px;
  background-color: #2a2a2a;
  color: #fff;
  margin-bottom: 20px;

  &:focus {
    outline: none;
    border-color: #45a049;
  }
`;

const CardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  width: 100%;
  max-width: 800px;
`;

const Card = styled(Link)`
  background-color: #2a2a2a;
  color: #f0f0f0;
  text-decoration: none;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  flex: 1 1 calc(33.333% - 40px);
  max-width: 250px;
  transition: transform 0.3s ease, background-color 0.3s ease;

  &:hover {
    transform: scale(1.05);
    background-color: #3c3c3c;
  }

  h3 {
    margin: 0 0 10px;
    font-size: 1.2rem;
  }
`;

const HomePage = () => {
  return (
    <Section>
      <SupportContent>
        <h1>Search Our Knowledge Base</h1>
        <p>Find answers to common questions or issues quickly.</p>
      </SupportContent>

      <SearchBox type="text" placeholder="Search..." />

      <CardContainer>
        <Card to="/">
          <h3>Submit a Ticket</h3>
          <p>Need help? Contact our support team directly.</p>
        </Card>
        <Card to="/">
          <h3>Pingcraft Rules</h3>
          <p>Learn about our community guidelines and rules.</p>
        </Card>
        <Card as="a" href="https://docs.pingcraft.io" target="" rel="noopener noreferrer">
  <h3>Pingcraft Docs</h3>
  <p>Explore our documentation for detailed guides.</p>
</Card>
      </CardContainer>
    </Section>
  );
};

export default HomePage;
